import { render, staticRenderFns } from "./ab-date-range.vue?vue&type=template&id=4c645ce4&"
import script from "./ab-date-range.vue?vue&type=script&lang=js&"
export * from "./ab-date-range.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports